window.UpdateClaims = function (data) {
    return new Promise(function (resolve, reject) {
        var url = "/UpdateClaims";

        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(url, requestOptions)
            .then(response => response.json()).then(data => resolve(data)).catch(error => reject(false));
    })
}